// src/components/SubscriptionBanner.js
//
// Banner di avviso per pagamento fallito (past_due).
// Adattato per Master HR (useUser, firebase imports).

import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { db } from "../firebase";
import { useUser } from "../UserContext";
import { useBilling } from "../context/BillingContext";
import { initializeApp } from "firebase/app";

export default function SubscriptionBanner() {
  const { activeCenterId } = useUser();
  const { subscription, isPastDue } = useBilling();
  const [loading, setLoading] = useState(false);

  if (!isPastDue) return null;

  const gracePeriodEnds = subscription.gracePeriodEndsAt?.toDate
    ? subscription.gracePeriodEndsAt.toDate()
    : subscription.gracePeriodEndsAt
      ? new Date(subscription.gracePeriodEndsAt)
      : null;

  let daysLeft = 0;
  if (gracePeriodEnds) {
    daysLeft = Math.max(0, Math.ceil(
      (gracePeriodEnds.getTime() - Date.now()) / (24 * 60 * 60 * 1000)
    ));
  }

  const handleUpdateCard = async () => {
    setLoading(true);
    try {
      const functions = getFunctions(undefined, "europe-west1");
      const getPortalUrl = httpsCallable(functions, "getStripePortalUrl");
      const result = await getPortalUrl({ centerId: activeCenterId });
      window.open(result.data.portalUrl, "_blank");
    } catch (err) {
      console.error("Errore apertura portale:", err);
      alert("Errore nell'apertura del portale di pagamento. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  const isUrgent = daysLeft <= 5;

  return (
    <div style={{
      margin: "0 0 16px 0",
      padding: "14px 18px",
      borderRadius: "12px",
      backgroundColor: isUrgent ? "#fef2f2" : "#fffbeb",
      border: `1px solid ${isUrgent ? "#fca5a5" : "#fde68a"}`,
      fontSize: "0.85rem",
    }}>
      <div style={{
        display: "flex", alignItems: "center", gap: "8px",
        marginBottom: "8px", fontWeight: "700",
        color: isUrgent ? "#991b1b" : "#92400e",
      }}>
        {isUrgent ? "⚠️" : "⚠️"}
        {isUrgent
          ? ` Sospensione tra ${daysLeft} giorn${daysLeft === 1 ? "o" : "i"}!`
          : " Pagamento non riuscito"
        }
      </div>

      <p style={{
        margin: "0 0 12px 0", lineHeight: "1.5",
        color: isUrgent ? "#7f1d1d" : "#78350f", fontSize: "0.82rem",
      }}>
        {isUrgent
          ? "Aggiorna subito il metodo di pagamento per evitare la sospensione del servizio."
          : `Hai ancora ${daysLeft} giorni per aggiornare il metodo di pagamento.`
        }
      </p>

      <button
        onClick={handleUpdateCard}
        disabled={loading}
        style={{
          width: "100%", padding: "10px",
          backgroundColor: isUrgent ? "#dc2626" : "#f59e0b",
          color: "white", border: "none", borderRadius: "8px",
          fontSize: "0.85rem", fontWeight: "600",
          cursor: loading ? "not-allowed" : "pointer",
          display: "flex", justifyContent: "center",
          alignItems: "center", gap: "6px",
        }}
      >
        {loading ? "Caricamento..." : "💳 Aggiorna Carta"}
      </button>
    </div>
  );
}